const fonts = {
  body: '"Mulish", sans-serif',
  heading: '"Mulish", sans-serif',
  mono: '"Fira Code", Menlo, monospace',
}

export default fonts
